import ApiRoutes from "../../../constants/api-routes";
import { hneAdminApi } from "../../../service";

export const authentication = async (body) =>
  hneAdminApi.post(`${ApiRoutes.SIGN_IN}`, body);
